export default function VideoPlayer ({property, handleClose, isPlaying, setIsPlaying, videoRef}) {
    const togglePlayPause = () => {
        const video = videoRef.current;
        if (video.paused || video.ended) {
            video.play();
            setIsPlaying(true);
        } else {
            video.pause();
            setIsPlaying(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center">
            <div className="relative w-[80%] md:w-full my-5 max-w-3xl mx-auto">
                <video
                    ref={videoRef}
                    className="w-full"
                    onEnded={() => setIsPlaying(false)}
                    controls={true}
                >
                    <source src={property.videos[0].path} type="video/webm"/>
                    Il tuo browser non supporta il tag video.
                </video>

                {/* Bottone play/pausa */}
                <button
                    onClick={togglePlayPause}
                    className="absolute bottom-[47%] left-[47%] z-10"
                >
                    {!isPlaying &&
                        <img
                            src={"/icons/play-icon.svg"}
                            alt={"play"}
                            className="w-10 h-10"
                        />
                    }
                </button>

                {/* Bottone chiudi */}
                <button
                    onClick={handleClose}
                    className="absolute top-[-20px] right-[-25px] text-white text-3xl font-bold"
                >
                    <img
                        src={"/icons/close-icon.svg"}
                        alt={"close"}
                        className="w-[20px] h-[20px]"
                    />
                </button>
            </div>
        </div>
    )
}